// busca codigo de pais | https://stackoverflow.com/questions/391979/how-to-get-clients-ip-address-using-javascript
import helpers from "./app_helpers";
import trad from "./app_trad";
import Vue from "vue";
import infoo from "../plugins/infoo";

function isMobile() {
  let ua = navigator.userAgent;
  return (
    ua.indexOf("Android") > 0 ||
    ua.indexOf("iPhone") > 0 ||
    ua.indexOf("webOS") > 0 ||
    ua.indexOf("iPod") > 0 ||
    ua.indexOf("iPad") > 0 ||
    ua.indexOf("BlackBerry") > 0
  );
}

const app = {
  namespaced: true,
  modules: { helpers, trad },
  state: {
    afterLogin: false,
    context: {
      cod: "",
      hoy: "",
      lng: "",
      min: "",
      max: "",
      ver: ""
    },
    loadBefore: [],
    params: {
      fb: {},
      lecturas: {
        diasMax: 15
      },
      licen: {
        diasGratis: 15
      },
      langs: [
        { cod: "es", name: "Español", rtl: false },
        { cod: "pt", name: "Português", rtl: false }
      ],
      bookVersions: [
        {
          cod: "es",
          lng: "es",
          ver: "",
          name: "Español",
          min: "2020-04-04",
          timeFormat: "ampm"
        },
        {
          cod: "pt",
          lng: "pt",
          ver: "",
          name: "Português",
          min: "2020-05-01",
          timeFormat: "24hr"
        },
        {
          cod: "esar",
          lng: "es",
          ver: "ar",
          name: "Argentina",
          min: "2020-04-04",
          timeFormat: "ampm"
        },
        {
          cod: "esbo",
          lng: "es",
          ver: "bo",
          name: "Bolivia",
          min: "2020-04-04",
          timeFormat: "ampm"
        },
        {
          cod: "escl",
          lng: "es",
          ver: "cl",
          name: "Chile",
          min: "2020-04-04",
          timeFormat: "ampm"
        },
        {
          cod: "esco",
          lng: "es",
          ver: "co",
          name: "Colombia",
          min: "2020-04-04",
          timeFormat: "ampm"
        },
        {
          cod: "escr",
          lng: "es",
          ver: "cr",
          name: "Costa Rica",
          min: "2020-04-04",
          timeFormat: "ampm"
        },
        {
          cod: "escu",
          lng: "es",
          ver: "cu",
          name: "Cuba",
          min: "2020-04-04",
          timeFormat: "ampm"
        },
        {
          cod: "esdo",
          lng: "es",
          ver: "do",
          name: "República Dominicana",
          min: "2020-04-04",
          timeFormat: "ampm"
        },
        {
          cod: "esec",
          lng: "es",
          ver: "ec",
          name: "Ecuador",
          min: "2020-04-04",
          timeFormat: "ampm"
        },
        {
          cod: "essv",
          lng: "es",
          ver: "sv",
          name: "El Salvador",
          min: "2020-04-04",
          timeFormat: "ampm"
        },
        {
          cod: "esgt",
          lng: "es",
          ver: "gt",
          name: "Guatemala",
          min: "2020-04-04",
          timeFormat: "ampm"
        },
        {
          cod: "esht",
          lng: "es",
          ver: "ht",
          name: "Haiti",
          min: "2020-04-04",
          timeFormat: "ampm"
        },
        {
          cod: "eshn",
          lng: "es",
          ver: "hn",
          name: "Honduras",
          min: "2020-04-04",
          timeFormat: "ampm"
        },
        {
          cod: "esmx",
          lng: "es",
          ver: "mx",
          name: "México",
          min: "2020-04-04",
          timeFormat: "ampm"
        },
        {
          cod: "esms",
          lng: "es",
          ver: "ms",
          name: "Montserrat",
          min: "2020-04-04",
          timeFormat: "ampm"
        },
        {
          cod: "esni",
          lng: "es",
          ver: "ni",
          name: "Nicaragua",
          min: "2020-04-04",
          timeFormat: "ampm"
        },
        {
          cod: "espa",
          lng: "es",
          ver: "pa",
          name: "Panamá",
          min: "2020-04-04",
          timeFormat: "ampm"
        },
        {
          cod: "espy",
          lng: "es",
          ver: "py",
          name: "Paraguay",
          min: "2020-04-04",
          timeFormat: "ampm"
        },
        {
          cod: "espe",
          lng: "es",
          ver: "pe",
          name: "Perú",
          min: "2020-04-04",
          timeFormat: "ampm"
        },
        {
          cod: "espr",
          lng: "es",
          ver: "pr",
          name: "Puerto Rico",
          min: "2020-04-04",
          timeFormat: "ampm"
        },
        {
          cod: "esuy",
          lng: "es",
          ver: "uy",
          name: "Uruguay",
          min: "2020-04-04",
          timeFormat: "ampm"
        },
        {
          cod: "esve",
          lng: "es",
          ver: "ve",
          name: "Venezuela",
          min: "2020-04-04",
          timeFormat: "ampm"
        },
        {
          cod: "ptbr",
          lng: "pt",
          ver: "br",
          name: "Brasil",
          min: "2020-05-01",
          timeFormat: "24hr"
        }
      ],
      roles: [
        { id: 0, st: "Soporte Técnico" },
        { id: 1, an: "Anónimo" },
        { id: 2, in: "Invitado" },
        { id: 3, su: "Suscriptor" },
        { id: 4, so: "Socio" },
        { id: 5, pv: "Punto Venta" },
        { id: 5, ma: "Mayorista" },
        { id: 7, di: "Distribuidor" },
        { id: 8, co: "Coordinador" },
        { id: 9, cp: "CDLM Ppal" },
        { id: 10, es: "Escritor" },
        { id: 11, re: "Revisor" },
        { id: 12, ed: "Editor" }
      ]
    },
    resources: 0,
    sizes: {
      bodyH: 0,
      bodyW: 0,
      content: 0, // tamaño de <main>
      height: 0,
      iniH: 0, // alto inicial
      iniW: 0, // ancho inicial
      isMobile: undefined,
      total: 0, // alto y ancho inicial
      width: 0
    },
    msg: ""
  },
  getters: {
    afterLogin(state) {
      return state.afterLogin;
    },
    context(state) {
      return state.context;
    },
    loadBefore(state) {
      return state.loadBefore;
    },
    params(state) {
      return state.params;
    },
    resources(state) {
      return state.resources;
    },
    sizes(state) {
      return state.sizes;
    },
    msg(state) {
      return state.msg;
    }
  },
  mutations: {
    addResource(state, cant) {
      Vue.set(state, "resources", state.resources + cant);
    },
    goAfterLogin(state, to) {
      Vue.set(state, "afterLogin", to);
    },
    loadBefore(state, payload) {
      let txt = JSON.stringify(payload);

      if (state.loadBefore.indexOf(txt) === -1) {
        state.loadBefore.push(txt);
      }
    },
    loadBeforeClear(state) {
      Vue.set(state, "loadBefore", []);
    },
    resize(state, payload) {
      // https://stackoverrun.com/es/q/7763317
      let isMobile = state.sizes.isMobile;
      // let keyboardEnable = state.sizes.total > window.innerHeight + window.innerWidth;

      let h = window.innerHeight;
      let w = window.innerWidth;

      if (!isMobile) {
        // ancho calculado
        let w1 = window.innerWidth;
        let w2 = Math.floor((h / 205) * 134);
        w = w1 < w2 ? w1 : w2;
      }

      let top = payload.vuetify.application.top;
      top = top !== 0 ? top : 96; // 96 alto de app-bar

      let obj = {
        bodyH: payload.bodyRef.clientHeight,
        bodyW: payload.bodyRef.clientWidth,
        height: h,
        width: w,
        content: h - top
      };
      Vue.set(state, "sizes", obj);
    },
    setContext(state, context) {
      Vue.set(state, "context", context);
      this.$local.set("app/context", context);
    },
    setIniSizes(state) {
      let h = window.innerHeight;
      let w = window.innerWidth;
      let obj = {
        iniH: h,
        iniW: w,
        total: h + w,
        isMobile: isMobile()
      };
      Vue.set(state, "sizes", obj);
    },
    msg(state, msg) {
      state.msg = msg;
    }
  },
  actions: {
    defineContext({ commit, getters, rootGetters }) {
      let params = getters["params"];
      let userConfig = rootGetters["user/config"];

      // define lng
      let lng = userConfig.mdd.lng || "es";
      let ver = userConfig.mdd.ver || "";
      let cod = ver ? lng + ver : lng;

      // fechas
      var hoy = infoo.hoy;
      // define min
      let bvs = params.bookVersions;
      let index = bvs.findIndex(bv => bv.cod === cod);
      let min = index ? bvs[index].min : hoy.min;

      let diasMax = params.lecturas.diasMax * 24 * 60 * 60 * 1000;
      let max = hoy.fecha.getTime() + diasMax;
      max = new Date(max);

      commit("setContext", {
        lng: lng,
        ver: ver,
        cod: cod,
        min: min,
        max: max.toISOString().slice(0, 10),
        hoy: hoy
      });
    },
    readyToGo({ commit, getters, dispatch, rootGetters }) {
      let appReady = getters["resources"] == 100;
      let userReady = rootGetters["user/ready"];

      // app y usuario listos
      if (appReady && userReady) {
        let userConfig = rootGetters["user/config"];

        // cargar lectio y notas de hoy
        let hoy = infoo.hoy;
        let params = {
          lng: userConfig.mdd.lng,
          ver: userConfig.mdd.ver,
          anio: hoy.anio,
          mes: hoy.mes,
          dia: hoy.dia
        };

        // let payload = {
        //   fecha: hoy.iso,
        //   cant: 15
        // };

        dispatch("lectio/load", params, { root: true });
        dispatch("user/notes/getLocalDoc", params, { root: true });
        // dispatch("user/notes/getLocalDocsAntesDe", payload, { root: true });

        // ejecuta la carga pendiente
        getters.loadBefore.forEach(work => {
          let obj = JSON.parse(work);
          dispatch(obj.dispatch, obj.payload, { root: true });
        });

        commit("loadBeforeClear");

        // si es el arranque de la app, ejecuta la ruta pendiente
        infoo.appStart = true;
        if (infoo.appStart) {
          this.$router.push(infoo.toAfterStart);
        }

        let to = getters["afterLogin"] || "home";
        let from = this.$router.history.current.name;
        if (from === "login") {
          commit("goAfterLogin", false);
          this.$router.push(to).catch(e => {
            console.log(e);
          });
        }
      }
    },
    saveErrorReport(ctx, error) {
      // TODO: production change
      // TODO: validar el acceso a internet con un helper test y documentarlo
      // si no tiene acceso a internet debe registrar local los errores y en el proximo
      // inicio de sesion valido subirlos a la app, verificar si esto lo hace fb en segundo plano
      let e = new Error(error.e);

      // eslint-disable-next-line no-unused-vars
      let data = {
        c: ctx.rootGetters["app/helpers/clientInfo"],
        // t: this.$fb.firebase_.firestore.Timestamp.now().seconds,
        t: infoo.timeStamp(),
        e: {
          // description
          de: e.description || "_",
          // fileName
          fi: e.fileName || "_",
          // lineNumber
          li: e.lineNumber || "_",
          // message
          me: e.message || "_",
          // name
          na: e.name || "_",
          // number
          nu: e.number || "_",
          // stack
          st: e.stack || "_"
        },
        d: {
          line: error.line,
          src: error.src
        }
      };

      if (process.env.NODE_ENV === "production") {
        this.$local.set(data.t, data);
        // this.$collection.errors.add(data);
      } else {
        console.error(data);
      }
    },
    start({ commit, dispatch }) {
      // dispatch loader start
      // TODO: verifica la instalación de la aplicación y errores

      // get contexto
      // await dispatch("getContext");

      // get client location
      dispatch("helpers/getClientLocation").then(() => {
        // get user auth
        dispatch("user/getAuth", "", { root: true });

        // get user config
        dispatch("user/getConfig", "", { root: true });

        // get user config
        dispatch("user/getLicense", "", { root: true });

        dispatch("defineContext");

        commit("addResource", 100);
        dispatch("readyToGo", undefined);
      });
    }
  }
};

export default app;
